import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import {
  ActiveInActiveVehicle,
  deleteVehicle,
  getAllVehicle,
} from "../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import Switch from "../../Components/Common/Switch";
import DeleteModal from "../../Components/Common/DeleteModal";
import { resetForm } from "../../slices/vehicle/reducer";
const MasterVehicle = () => {
  const dispatch = useDispatch();
  const { vehicles, loading } = useSelector((state) => state.Vehicle);

  const [reload, setReload] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    dispatch(resetForm());
    dispatch(getAllVehicle());
  }, [reload]);

  const handleChange = (data) => {
    let obj = { ID: +data.ID, IsActive: !data.IsActive };

    dispatch(ActiveInActiveVehicle(obj)).then((res) => {
      if (res.payload && res.payload.Status === 200) {
        setReload(!reload);
      }
    });
  };

  const onClickDelete = (data) => {
    setDeleteModal(true);
    setDeleteData(data);
  };

  const onDeleted = () => {
    let obj = {
      ID: +deleteData?.ID,
    };
    dispatch(deleteVehicle(obj)).then((res) => {
      if (res.payload && res.payload.Status === 200) {
        setReload(!reload);
        setDeleteModal(false);
      }
    });
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Vehicle Master" pageTitle="Vehicle" />
        <Row>
          <Col xl={12}>
            <Card color="dark" outline>
              <CardHeader className="bg-light">
                <Row className="align-items-center">
                  <Col md={4}>
                    <h4 className="card-title mb-0">Vehicle Master</h4>
                  </Col>
                  <Col md={8} className="text-end">
                    <Link to="/vehicle/create">
                      <Button color="primary">
                        <i className="las la-plus"></i>Add
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive">
                      <Table
                        className="align-middle table-nowrap mb-0"
                        striped
                        responsive
                        hover
                      >
                        <thead>
                          <tr className="table-header">
                            <th scope="col">City</th>
                            <th scope="col">Vehicle</th>
                            <th scope="col" className="text-end">
                              Capacity
                            </th>
                            <th scope="col" className="text-end">
                              KM/Day
                            </th>
                            <th scope="col" className="text-end">
                              Rate/KM
                            </th>
                            <th scope="col" className="text-end">
                              D.A./Day
                            </th>
                            <th scope="col" className="col-1 text-center">
                              Status
                            </th>
                            <th scope="col" className="col-1 text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading &&
                          Array.isArray(vehicles) &&
                          vehicles.length ? (
                            vehicles.map((vehicle, index) => (
                              <tr key={index}>
                                <td>
                                  <Link to={`/vehicle/update/${vehicle.ID}`}>
                                    {vehicle.CityName}
                                  </Link>
                                </td>
                                <td>{vehicle.VehicleType}</td>
                                <td className="text-end">
                                  {vehicle.NoOfSeats}
                                </td>
                                <td className="text-end">{vehicle.KmPerDay}</td>
                                <td className="text-end">
                                  {vehicle.RatePerKm}
                                </td>
                                <td className="text-end">
                                  {vehicle.DriverAllowancePerDay
                                    ? vehicle.DriverAllowancePerDay
                                    : 0}
                                </td>
                                <td className="text-center">
                                  <Switch
                                    onChange={() => handleChange(vehicle)}
                                    checked={vehicle?.IsActive}
                                  />
                                </td>

                                <td className="text-center">
                                  <div className="hstack gap-3 justify-content-center">
                                    <Link
                                      to={`/vehicle/update/${vehicle.ID}`}
                                      className="link-success fs-18"
                                    >
                                      <i className="ri-edit-line"></i>
                                    </Link>
                                    <div
                                      className="hstack gap-3 justify-content-center "
                                      role="button"
                                      onClick={() => onClickDelete(vehicle)}
                                    >
                                      <i className=" ri-delete-bin-fill text-danger fs-18"></i>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : loading ? (
                            <tr>
                              <td colSpan={10}>
                                <Loader />
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan={10}>No Vehicle found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <DeleteModal
            show={deleteModal}
            onCloseClick={() => setDeleteModal(false)}
            onDeleteClick={() => onDeleted()}
          />
        </Row>
      </Container>
    </div>
  );
};

export default MasterVehicle;
